export const GET_CANNED_EMAILS = 'GET_CANNED_EMAILS';
export const SET_CANNED_EMAILS = 'SET_CANNED_EMAILS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_CANNED_EMAIL = 'SET_CANNED_EMAIL';
export const ADD_CANNED_EMAIL = 'ADD_CANNED_EMAIL';
export const EMPTY_CANNED_EMAIL = 'EMPTY_CANNED_EMAIL';
export const DELETE_CANNED_EMAIL = 'DELETE_CANNED_EMAIL';
export const EDIT_CANNED_EMAIL = 'EDIT_CANNED_EMAIL';
export const UPDATE_CANNED_EMAIL = 'UPDATE_CANNED_EMAIL';
export const SET_CANNED_EMAIL_FILTER = 'SET_CANNED_EMAIL_FILTER';